// Formato de moneda para montos de la plataforma (pesos mexicanos).
//
// Regla de negocio (SV2): la PARTE DECIMAL del monto se "ajusta a medios":
//   - decimal en [0.45, 1.00) -> sube a .50  (1.45, 1.48, 1.49, 1.75, 1.99 -> *.50)
//   - decimal en [0.00, 0.45) -> baja a .00  (1.44, 1.30 -> *.00)
// Nunca sube al entero siguiente (1.99 -> 1.50). Se muestran 2 decimales para
// que el ".50" sea visible. Ejemplo: 1234.90 -> "$1,234.50"; 1234.10 -> "$1,234.00".

const MXN = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

// Umbral de la parte decimal a partir del cual el monto "sube" a .50.
const HALF_THRESHOLD = 0.45

// Ajusta un número al múltiplo de 0.50 según la regla SV2 (ver arriba).
export const roundHalfDown = (n) => {
  const whole = Math.floor(n)
  const frac = n - whole
  return whole + (frac >= HALF_THRESHOLD ? 0.5 : 0)
}

// Formatea un número (o string numérico) como MXN con la regla SV2 (snap a
// .00/.50). Valores nulos/no numéricos devuelven el fallback.
export const fmtMXN = (value, fallback = "$0.00") => {
  const n = Number(value)
  if (value === null || value === undefined || value === "" || !Number.isFinite(n)) {
    return fallback
  }
  return MXN.format(roundHalfDown(n))
}

export default fmtMXN
